import { FC, PropsWithChildren } from 'react';
import './DashboardTableSummary.scss';

export const DashboardTableSummary: FC<PropsWithChildren> = ({ children }) => {
  return <div className="DashboardTableSummary">{children}</div>;
};
